export default __webpack_public_path__ + "static/media/7SS521.3acf0024.jpg";